// extracted by mini-css-extract-plugin
export default {"root":"notification-bar_root__8tCXR","item":"notification-bar_item__nj5XE","SUCCESS":"notification-bar_SUCCESS__oe0T1","ERROR":"notification-bar_ERROR__fWhhA"};